import React, { useCallback, useState } from 'react';

import Select, { SelectOption } from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

type Props = {
  placeholder?: string;
  onChange: ((option: SelectOption) => void) | ((option: SelectOption[]) => void);
  value: SelectOption | null | SelectOption[];
  width?: string;
  multi?: boolean;
  disabled?: boolean;
  className?: string;
  closeOnSelect?: boolean;
  onSelectResetsInput?: boolean;
};

type Response = {
  workerTeams: any[];
};

const SelectWorkerTeam = (props: Props) => {
  const [curTimeout, setCurTimeout] = useState<NodeJS.Timeout | null>(null);

  const fetchWorkerTeams = useCallback(
    async (name: any) => {
      if (!name) {
        return (async () => [])();
      }

      if (curTimeout) {
        clearTimeout(curTimeout);
      }

      return new Promise(resolve => {
        const newTimeout = setTimeout(async () => {
          try {
            const { workerTeams } = await apiFetch<Response>(
              null,
              `corp-api/find/teams?name=${name}`,
            );
            resolve({
              options: workerTeams.map(team => ({
                label: team.name,
                value: team.id,
              })),
            });
          } catch (error) {
            defaultApiFetchErrorHandler(error, { handleHttp: true });
          }
          return [];
        }, 500);
        setCurTimeout(newTimeout);
      });
    },
    [curTimeout],
  );

  return <Select loadOptions={fetchWorkerTeams} {...props} />;
};

export default SelectWorkerTeam;
